export const ErrorCodes = {
  EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
  // feature for future
  // ACCOUNT_BLOCKED: 'ACCOUNT_BLOCKED',
  // INSUFFICIENT_PERMISSIONS: 'INSUFFICIENT_PERMISSIONS',
  // SESSION_EXPIRED: 'SESSION_EXPIRED',
  // GENERAL_403: 'GENERAL_403',
};
